// Utility helpers to build consistent display labels across the app.
export const formatClientName = (data, fallback = 'Unknown Client') => {
  if (!data) return fallback;

  // Check if client_id is NULL (unassigned appointment from Pabau)
  const clientId = data.client_id ?? data.id;
  if (!clientId || clientId === null) {
    return null; // Return null to signal "unassigned" - caller should show badge instead
  }

  const first = data.client_first_name ?? data.first_name;
  const last = data.client_last_name ?? data.last_name;
  const nameFromParts = [first, last].filter(Boolean).join(' ').trim();
  if (nameFromParts) {
    return nameFromParts;
  }

  const full = data.client_name ?? data.full_name ?? data.client_full_name;
  if (typeof full === 'string' && full.trim()) {
    return full.trim();
  }

  const email = data.client_email ?? data.email;
  if (typeof email === 'string' && email.trim()) {
    return email.trim();
  }

  const customRef = data.custom_id ?? data.client_custom_id ?? data.client_reference;
  if (customRef !== undefined && customRef !== null && String(customRef).trim()) {
    return `Client ${String(customRef).trim()}`;
  }

  // If we have a client_id but no other info, this is data quality issue
  // Return null to signal unassigned (should show badge)
  return null;
};

export const formatFormName = (form, fallback = 'Unknown Form') => {
  if (!form) return fallback;

  const name =
    form.form_name ??
    form.name ??
    form.form_template_name ??
    form.title ??
    form.template_name;

  if (typeof name === 'string' && name.trim()) {
    return name.trim();
  }

  const category = form.form_category ?? form.category;
  if (typeof category === 'string' && category.trim()) {
    return `${category.trim()} Form`;
  }

  return fallback;
};

export const formatFormCategory = (form, fallback = 'N/A') => {
  const category =
    form?.form_category ??
    form?.category ??
    form?.type ??
    form?.template_category;

  if (typeof category === 'string' && category.trim()) {
    return category.trim();
  }

  return fallback;
};
